export const creditCardLimitInfo = {
    types: [] as string[],
};
